import { React, useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import SpeakSystemModal from "./SpeakSystemModal";
import SpeakConfirmationModal from "../../components/setup_modals/SpeakConfirmationModal";
import { isSPEAKABC } from "../../libs/env";

const SystemCheckModal = ({ data, isOpen, toggle, assessmentStarted, setAssessmentStarted }) => {
  const [isConfirmSetting, setIsConfirmSetting] = useState(false);
  const [IsconfirmCondition, setIsconfirmCondition] = useState(false);

  const TextContent = {
    speakABC: {
      checkSystem: "Check your speakers, microphone and internet speed.",
      quietEnvironment: "Ensure you are in a quiet environment.",
      testMicrophone: "Test your microphone.",
      testSpeakers: "Play the recording to test your speakers.",
      testInternet: "Internet speed.",
      testBrowser: "Browser compatibility.",
      testConfirmation1: "I have tested the microphone, speakers, and internet speed.",
      testConfirmation2: `I consent to share my data with SpeakABC and confirm that my data will not be
              shared with third parties in compliance with data protection laws.`
    },
    default: {
      checkSystem: "Check your speakers, microphone and internet speed. 檢查您的揚聲器、麥克風和網速。",
      quietEnvironment: "Ensure you are in a quiet environment. 確保您處於安靜的環境中。",
      testMicrophone: "Test your microphone. 測試您的麥克風。",
      testSpeakers: "Play the recording to test your speakers. 播放錄音以測試您的揚聲器。",
      testInternet: "Internet speed. 網速。",
      testBrowser: "Browser compatibility. 瀏覽器相容性。",
      testConfirmation1: "I have tested the microphone, speakers, and internet speed. 我已測試麥克風、揚聲器和網速。",
      testConfirmation2: `I consent to share my data with Lingtung University, Gradingly
              Limited, and Weltbenchmark, and confirm that my data will not be
              shared with third parties in compliance with data protection laws.
              我同意分享我的數據給嶺東科技大學 (Lingtung University)、Gradingly
              Limited 和
              Weltbenchmark，並確認我的數據將不會與第三方共享，並將遵循數據保護法律。`
    }
  };

  let SystemTextContent = TextContent.default;
  if (isSPEAKABC) {
    SystemTextContent = TextContent.speakABC;
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="modal-dialog-centered subscription-modal-lg"
      backdrop="static"
    >
      <ModalBody className="px-0 py-3" data-tc="system-requirement-modal">
        <SpeakSystemModal data={data} assessmentStarted={assessmentStarted} toggle={toggle} SystemTextContent={SystemTextContent} />
        <SpeakConfirmationModal
          data={data} 
          assessmentStarted={assessmentStarted}
          toggle={toggle}
          setAssessmentStarted={setAssessmentStarted}
          setisConfirmSetting={setIsConfirmSetting}
          isConfirmSetting={isConfirmSetting}
          setIsconfirmCondition={setIsconfirmCondition}
          IsconfirmCondition={IsconfirmCondition}
          SystemTextContent={SystemTextContent}
        />
      </ModalBody>
    </Modal>
  );
};

SystemCheckModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

SystemCheckModal.defaultProps = {
  isOpen: false,
};

export default SystemCheckModal;
